import React from 'react';
import styles from './PrivacyPolicy.module.css';

const PrivacyPolicy = () => {
    return (
        <div className={styles.privacyPage}>
            <div className={styles.container}>
                <header className={styles.header}>
                    <h1>Privacy Policy</h1>
                    <p className={styles.lastUpdated}>Last updated: {new Date().toLocaleDateString()}</p>
                </header>

                <main className={styles.content}>
                        <section className={styles.section}>
                            <h2>1. Introduction</h2>
                            <p>
                            Welcome to Our Company. We are committed to protecting your personal information
                            and your right to privacy. If you have any questions or concerns about this
                            privacy notice or our practices with regard to your personal information,
                            please contact us at our contact page.
                            </p>
                        </section>

                        <section className={styles.section}>
                            <h2>2. Information We Collect</h2>
                            <p>We collect personal information that you voluntarily provide to us when you:</p>
                            <ul>
                                <li>Register on our website</li>
                                <li>Express an interest in obtaining information about us or our products and services</li>
                                <li>Participate in activities on the website</li>
                                <li>Otherwise contact us</li>
                            </ul>
                        </section>

                    <section className={styles.section}>
                        <h2>3. How We Use Your Information</h2>
                        <p>We use personal information collected via our website for a variety of business purposes described below:</p>
                        <ul>
                            <li>To facilitate account creation and logon process</li>
                            <li>To send administrative information to you</li>
                            <li>To fulfill and manage your orders</li>
                            <li>To post testimonials</li>
                            <li>To request feedback</li>
                            <li>To protect our services</li>
                        </ul>
                    </section>

                    <section className={styles.section}>
                        <h2>4. Cookies and Tracking Technologies</h2>
                        <p>
                        We may use cookies and similar tracking technologies to access or store information.
                        Specific information about how we use such technologies and how you can refuse
                        certain cookies is set out in our Cookie Policy.
                        </p>
                    </section>

                    <section className={styles.section}>
                        <h2>5. Contact Us</h2>
                        <p>
                        If you have questions or comments about this policy, you may contact us at
                        our contact page.
                        </p>
                    </section>
                </main>
            </div>
        </div>
    );
};

export default PrivacyPolicy;